import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, User } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const BottomNav = () => {
    const location = useLocation();
    const { t } = useLanguage();

    const navItems = [
        { 
            path: '/home', 
            label: null,
            icon: Home,
            testId: 'nav-home'
        },
        { 
            path: '/menu', 
            labelKey: 'menu',
            icon: null,
            testId: 'nav-menu'
        },
        { 
            path: '/cart', 
            label: null,
            icon: ShoppingBag,
            isCenter: true,
            testId: 'nav-cart'
        },
        { 
            path: '/my-yess', 
            labelKey: 'myYess',
            icon: null,
            testId: 'nav-my-yess'
        },
        { 
            path: '/profile', 
            label: null,
            icon: User,
            testId: 'nav-profile'
        },
    ];

    // Don't show on access/login pages
    if (location.pathname === '/' || location.pathname === '/login') {
        return null;
    }

    // Check if current page is a menu section page
    const menuSectionPages = ['/auction', '/gallery', '/about', '/charity', '/house-rules'];
    const isMenuSection = menuSectionPages.some(p => location.pathname.startsWith(p));

    return (
        <nav 
            className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 z-50"
            style={{ paddingBottom: 'env(safe-area-inset-bottom, 0)' }}
            data-testid="bottom-nav"
        >
            <div className="flex items-center justify-around max-w-lg mx-auto h-14">
                {navItems.map((item) => {
                    const isActive = location.pathname === item.path || 
                                   (item.path === '/home' && location.pathname === '/home') ||
                                   (item.path === '/menu' && isMenuSection);
                    
                    const Icon = item.icon;

                    return (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            data-testid={item.testId}
                            className={`flex flex-col items-center justify-center px-4 py-2 transition-colors ${
                                isActive ? 'text-black' : 'text-gray-400'
                            }`}
                        >
                            {Icon ? (
                                <Icon 
                                    className={`w-5 h-5 ${item.isCenter ? 'w-6 h-6' : ''}`} 
                                    strokeWidth={isActive ? 2 : 1.5}
                                />
                            ) : (
                                <span className={`text-xs tracking-wider uppercase ${
                                    isActive ? 'font-medium' : 'font-light'
                                }`}>
                                    {item.labelKey ? t(item.labelKey) : item.label}
                                </span>
                            )}
                        </NavLink>
                    );
                })}
            </div>
        </nav>
    );
};

export default BottomNav;
